import { FONT_BRIGHTNESS_MAPPING } from './constants';
import { fontSizes } from './fontSizes';
export const buttons = ({ themeVariables, }) => {
    const { buttonBorderRadius, secondaryButtonBackgroundColor, secondaryButtonFontBrightness, } = themeVariables;
    const defaultButton = {
        bg: 'primary',
        borderRadius: buttonBorderRadius,
        color: 'white',
        disabled: {
            opacity: 0.6,
        },
        fontSize: fontSizes[2],
        fontWeight: 1,
        hovered: {
            bg: 'primaryDark',
            color: 'white',
        },
        opacity: 1,
        pressed: {
            bg: 'primaryDarker',
            color: 'white',
        },
    };
    return {
        destroy: Object.assign(Object.assign({}, defaultButton), { bg: secondaryButtonBackgroundColor, color: FONT_BRIGHTNESS_MAPPING.asphalt[secondaryButtonFontBrightness], hovered: {
                bg: 'fire',
                color: 'white',
            }, pressed: {
                bg: 'fire',
                color: 'white',
            } }),
        dropdown: {
            bg: 'transparent',
            color: 'black',
            disabled: {
                opacity: 0.6,
            },
            fontSize: fontSizes[2],
            fontWeight: 0,
            opacity: 1,
            padding: 0,
        },
        inversed: Object.assign(Object.assign({}, defaultButton), { bg: 'white', color: 'primary' }),
        link: {
            bg: 'transparent',
            color: 'primary',
            disabled: {
                opacity: 0.6,
            },
            fontSize: fontSizes[2],
            fontWeight: 1,
            opacity: 1,
            padding: 0,
        },
        primary: defaultButton,
        secondary: Object.assign(Object.assign({}, defaultButton), { bg: secondaryButtonBackgroundColor, color: FONT_BRIGHTNESS_MAPPING.asphalt[secondaryButtonFontBrightness] }),
    };
};
//# sourceMappingURL=buttons.js.map